import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/platform/')({
  component: PlatformIndex,
})

/**
 * /platform root — redirects to the Tenants sub-section. There is
 * no real dashboard here yet; when a platform home with KPIs /
 * usage widgets lands, this route becomes the landing page and
 * the redirect goes away.
 */
function PlatformIndex() {
  return <Navigate to="/platform/tenants" replace />
}
